// A multi-part PO runs one flow per part, so a bare stage name ("Cutting")
// doesn't say what is being cut. Tag each active stage with its part type and
// keep each part's stages together, in the order the parts are listed on the PO.
export function activeStagesWithPart(po) {
  const parts = po.parts || [];
  const partOrder = new Map(parts.map((p, i) => [p.id, i]));
  const showPart = parts.length > 1;

  return (po.stageProgress || [])
    .filter((s) => s.status === "in_progress" || s.status === "overdue")
    .map((s) => ({
      ...s,
      partType: showPart
        ? parts.find((p) => p.id === s.poPartId)?.partType || null
        : null,
    }))
    .sort(
      (a, b) =>
        (partOrder.get(a.poPartId) ?? Number.MAX_SAFE_INTEGER) -
          (partOrder.get(b.poPartId) ?? Number.MAX_SAFE_INTEGER) ||
        a.stageOrder - b.stageOrder,
    );
}
